import { Modal } from 'components/Modal';
import { ConfirmationToken } from 'components/ConfirmationToken';
import { TextM } from 'components/Text';

interface IEscrowDetailsAccountDestinationDeleteConfirmationProps {
	isOpen: boolean;
	isLoading: boolean;
	message: string;
	onClose: () => void;
	onConfirm: (mfaToken: string) => void;
}

const EscrowDetailsAccountDestinationDeleteConfirmation = ({
	isOpen,
	isLoading,
	message,
	onClose,
	onConfirm,
}: IEscrowDetailsAccountDestinationDeleteConfirmationProps) => {
	return (
		<Modal
			title="Confirmar exclusão"
			isOpen={isOpen}
			width={480}
			onClose={onClose}
		>
			<ConfirmationToken
				isLoading={isLoading}
				onClose={onClose}
				onConfirm={onConfirm}
			>
				<TextM>{message}</TextM>
			</ConfirmationToken>
		</Modal>
	);
};

export default EscrowDetailsAccountDestinationDeleteConfirmation;
